import { z } from "zod";
import { customErrorMap, myPreProcess } from "../shared/validation/zod";
import { documentStatusSchema } from "./types";

z.setErrorMap(customErrorMap);

export const DocumentClosingSchema = z.object({

    // required
    id: z.number(), // id.
    business_id: z.number(), // business object id.
    document_closing_id: z.number(), // document object id that closing.
    document_closed_id: z.number(), // document object id that being closed.
    old_status: z.string(), // old document status
    status: documentStatusSchema, // the new document status after paid.
    reference: z.string(), // reference name to the original document being closed.
    amount: z.coerce.number(), // the document amount that need to pay.
    old_balance: z.coerce.number(), // old document balance
    balance: z.coerce.number(), // the amount remains after paid.

    created_at: z.string(),
    updated_at: z.string(),

})


export const DocumentClosingFormSchema = z.object({

    // optional in create
    id: z.number().optional(), // id.
    business_id: z.number().optional(), // business object id.
    document_closing_id: z.number().optional(), // document object id that closing.

    document_closed_id: z.number(), // document object id that being closed.
    name: z.string(), // document name and number
    old_status: z.string(), // old document status
    status: z.preprocess((val) => myPreProcess(val), documentStatusSchema), // the new document status after paid.
    reference: z.string(), // reference name to the original document being closed.
    amount: z.coerce.number(), // the document amount that need to pay.
    old_balance: z.coerce.number(), // old document balance
    balance: z.preprocess((val) => myPreProcess(val, Number(val)), z.coerce.number()), // the amount remains after paid.

});


export type DocumentClosing = z.infer<typeof DocumentClosingSchema>
export type DocumentClosingForm = z.infer<typeof DocumentClosingFormSchema>
